import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { routes } from 'app/routes/route-list';
import { WithTranslation, withTranslation } from 'react-i18next';
import { withRouter, RouteComponentProps } from 'react-router';
import { updateFormContext } from 'app/i18n/i18next';
import { getLocale } from 'app/api/helpers';

/**
 * Takes in a pathname and returns the associated section title
 * to be used
 *
 * @param {string} pathname
 * @returns {(string | undefined)}
 */
export const mapSectionTitleFromPath = (pathname: string): string | undefined => {
  const map = {
    [routes.application]          : 'Mortgage Application',
    [routes.applicationHomeEquity]: 'Home Equity Application',
    [routes.applicationPurchase]  : 'Mortgage Application - Purchase',
    [routes.applicationRefinance] : 'Mortgage Application - Refinance',
    [routes.autoPrequal]          : 'Mortgage Application - Pre-Qualification',
    [routes.autoPrequalEdit]      : 'Mortgage Application - Pre-Qualification',
    [routes.autoPrequalRenew]     : 'Mortgage Application - Pre-Qualification',
    [routes.contact]              : 'Contact Us',
    [routes.homeEquity]           : 'Get Home Equity Rates',
    [routes.purchase]             : 'Get Mortgage Rates - Purchase',
    [routes.refinance]            : 'Get Mortgage Rates - Refinance',
  };
  return map[pathname] || 'Home';
};

interface Props extends WithTranslation, RouteComponentProps {
  clientDisplayName: string;
}

const PageTitleComponent = ({ clientDisplayName, t, location }: Props) => {
  const { pathname } = location;
  const context      = updateFormContext(pathname);
  const namespace    = context || 'global';
  const sectionTitle = t(`${namespace}:window.title`, {
    defaultValue: mapSectionTitleFromPath(pathname),
  });
  const locale = getLocale();

  return sectionTitle ? (
    <Helmet htmlAttributes={{ lang : locale }}>
      <title >
        {sectionTitle ? `${sectionTitle} - ` : ''}
        {clientDisplayName}
      </title>
    </Helmet>
  ) : null;
};

const mapStateToProps = (state, ownProps) => {
  const { clientDisplayName } = state.config;
  return {
    clientDisplayName,
    ...ownProps,
  };
};

/**
 * Note: withRouter must come first
 *  See: https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/withRouter.md
 */
export default withRouter(
  connect(
    mapStateToProps,
    null,
  )(withTranslation()(PageTitleComponent)),
);
